import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-exercise-name"
export default class extends Controller {
  connect() {
    const checkboxes = document.querySelectorAll('input.toggle-exercise-name-checkbox');
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        const nameSelectDiv = document.querySelector('div#name-select-' + checkbox.dataset.index);
        const alternateNameInputDiv = document.querySelector('div#alternate-name-input-' + checkbox.dataset.index);
        if (checkbox.checked) {
          nameSelectDiv.style.display = 'none';
          alternateNameInputDiv.style.display = 'inherit';
        } else {
          nameSelectDiv.style.display = 'inherit';
          alternateNameInputDiv.style.display = 'none';
        }
      });
    });
  }
}
